/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatStreamRequest,
  ErrorResponse,
} from '../models/index';
import {
    ChatStreamRequestFromJSON,
    ChatStreamRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface StreamChatRequest {
    chatStreamRequest: ChatStreamRequest;
}

/**
 * 
 */
export class AIChatApi extends runtime.BaseAPI {

    /**
     * Sends a user message (and optional history) to the AI and streams back the response.
     * Stream chat responses from the AI
     */
    async streamChatRaw(requestParameters: StreamChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['chatStreamRequest'] == null) {
            throw new runtime.RequiredError(
                'chatStreamRequest',
                'Required parameter "chatStreamRequest" was null or undefined when calling streamChat().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/ai/chat/stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatStreamRequestToJSON(requestParameters['chatStreamRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sends a user message (and optional history) to the AI and streams back the response.
     * Stream chat responses from the AI
     */
    async streamChat(requestParameters: StreamChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamChatRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
